import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-failure-task-update',
  templateUrl: './failure-task-update.component.html',
  styleUrls: ['./failure-task-update.component.css']
})
export class FailureTaskUpdateComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
